/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Button, FormControl, InputLabel, Popover,
} from '@mui/material';
import moment from 'moment';
import React, { useState } from 'react';
import { CalendarPickerIcon } from 'src/icons';
import { twMerge } from 'tailwind-merge';
import { CommonElementProps } from '../elements/types';
import { getDefaultRanges } from './defaults';
import RangeDatePicker, { DateRangePickerProps } from './RangeDatePicker';
import { DateRange } from './types';

interface RangeDatePickerWrapperProps
  extends DateRangePickerProps,
  CommonElementProps<DateRange> {
  onRangeChange?: (dateRange: DateRange) => void,
}

const RangeDatePickerWrapper: React.FunctionComponent<RangeDatePickerWrapperProps> = function RangeDatePickerWrapper(props: RangeDatePickerWrapperProps) {
  const {
    locale, error, label, weekPicker, definedRanges, onRangeChange,
    value: defaultValue,
  } = props;
  const [open, setOpen] = useState(false);
  const popoverId = open ? 'multi-datepicker' : undefined;
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const [value, setValue] = useState<DateRange>(defaultValue || {
    startDate: undefined,
    endDate: undefined,
  });

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOnChange = (dateRange: DateRange) => {
    if (onRangeChange) {
      onRangeChange(dateRange);
    }
    setValue(dateRange);
    handleClose();
  };

  return (
    <FormControl>
      <InputLabel
        color="secondary"
        error={!!error}
        shrink
        className="text-[1.2rem] font-semibold -ml-3 -mt-[14px] text-[#28364C] focus:text-[#28364C]"
      >
        {label}
      </InputLabel>
      <Button
        ref={anchorEl}
        onClick={handleOpen}
        color="secondary"
        startIcon={<CalendarPickerIcon />}
        className={twMerge('justify-start custom-shadow')}
      >
        {!value.startDate && (
          <>Start date</>
        )}
        {value.startDate && moment(value.startDate).format('MMM DD, YYYY')}
        -
        {!value.endDate && (
          <>End date</>
        )}
        {value.endDate && moment(value.endDate).format('MMM DD, YYYY')}
      </Button>
      <Popover
        id={popoverId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <RangeDatePicker
          open
          initialDateRange={value}
          definedRanges={
            definedRanges || getDefaultRanges(new Date(), locale)
          }
          locale={locale}
          onChange={handleOnChange}
          weekPicker={weekPicker}
        />
      </Popover>
    </FormControl>
  );
};

RangeDatePickerWrapper.defaultProps = {
  onRangeChange: () => { },
};

export default RangeDatePickerWrapper;
